/*
  Jhilma product image customizer — ported from Indophilia (Impulse 6.0.1 -> 9.x)
  Changes vs. Indophilia original:
    - All .ymq-* code removed (dead code; YMQ app not installed)
    - Backend endpoint read from <body data-composite-endpoint> theme setting
      (fallback: hardcoded DO App Platform URL)
    - Reset image reads data-default-src set in Liquid (no hardcoded CDN URL)
    - Indophilia-specific "Shipping & Returns UPDATED pill" block intentionally omitted
  Data contract preserved: writes swatch names into .cart_properties inputs
  (properties[Neckline|Sleevetype|Bottomlength|Pantlength]) and the composite URL
  into .customize_image (properties[Customized image]).
*/
$(document).ready(function(){
  var COMPOSITE_ENDPOINT = document.body.getAttribute('data-composite-endpoint') ||
    'https://image-stitching-app-usu8y.ondigitalocean.app/compositeImage';

  // Popup open/close
  $(document).on("click", ".customize_button", function (e) {
    e.preventDefault();
    $(".ms_popup_wr").addClass("visible");
    $("body").css("overflow", "hidden");
  });
  $(document).on("click", ".ms_popup_overlay, .ms_close_btn", function () {
    $(".ms_popup_wr").removeClass("visible");
    $("body").css("overflow", "auto");
  });

  // Swatch functionality: layer selected piece over base image in popup preview
  function swatch_functionality(swatch){
    var input_name = $(swatch).attr('name');
    var image_src = $(swatch).prev().attr('src');
    var swatch_name = $(swatch).attr('data-swatch-name-display');
    if(input_name == 'neckline'){
      $('.style_main :first-child').text(swatch_name);
      $('.image_group_main .top_image.image_bg').attr("src", image_src);
      $('.image_group_main .top_image.image_fg').fadeOut(500, function() {
        $(this).attr("src", image_src).fadeIn(500);
      });
    } else if(input_name == 'sleevetype'){
      $('.style_main :nth-child(2)').text(swatch_name);
      $('.image_group_main .middle_image.image_bg').attr("src", image_src);
      $('.image_group_main .middle_image.image_fg').fadeOut(500, function() {
        $(this).attr("src", image_src).fadeIn(500);
      });
    } else if(input_name == 'bottomlength' || input_name == 'pantlength'){
      $('.style_main :nth-child(3)').text(swatch_name);
      $('.image_group_main .bottom_image.image_bg').attr("src", image_src);
      $('.image_group_main .bottom_image.image_fg').fadeOut(500, function() {
        $(this).attr("src", image_src).fadeIn(500);
      });
    }
  }

  // On load, apply any pre-checked swatches
  $('.swatch_slider_main .swatch_single .swatch_input').each(function () {
    if($(this).is(':checked')){
      swatch_functionality(this);
    }
  });

  // On change, update preview + selected swatch display
  $('.swatch_input').on('change', function(){
    swatch_functionality(this);
    var selectedImage = $(this).parents('.swatch_item').find('.swatch_img').attr('src');
    $(this).parents('.slider_with_default').find('.swatch_single.only_swatch .swatch_img').attr('src', selectedImage);
    var selectedStyle = $(this).parents('.swatch_item').find('.swatch_text').text();
    $(this).parents('.slider_with_default').find('.swatch_single.only_swatch .swatch_text').text(selectedStyle);
  });

  // Swiper sliders for swatch rows
  $(function() {
    renderSlides('swiper1','.swipe1','.swiper-button-next1','.swiper-button-prev1');
    renderSlides('swiper2','.swipe2','.swiper-button-next2','.swiper-button-prev2');
    renderSlides('swiper3','.swipe3','.swiper-button-next3','.swiper-button-prev3');
    renderSlides('swiper4','.swipe4','.swiper-button-next4','.swiper-button-prev4');
  });

  function renderSlides(swipers,selector,nextBtn,prevBtn) {
    var swipers = new Swiper(selector, {
      slidesPerView: 'auto',
      slidesPerGroup: 1,
      spaceBetween: 10,
      loop: false,
      navigation: {
          nextEl: nextBtn,
          prevEl: prevBtn,
      }
    });
  }

  // Select style: write properties, request composite, swap gallery image
  $(document).on('click', '.submit_button', function(){
    $('.customize_btn').hide();
    $('.reset_button').addClass('show_reset');
    $('.product-slideshow').addClass('active');
    $('.swatch_input:checked').each(function(){
      var swatch_name = $(this).attr('data-swatch-name-display');
      var selected_swatch_image = $(this).next('.swatch_img').attr('src');
      var selcted_swatch_name = $(this).attr('name');
      $('.pg_swatch_img_text').each(function(){
        var data_name = $(this).attr('data-name');
        if(selcted_swatch_name == data_name){
          $(this).find('img').attr('src', selected_swatch_image);
          $(this).find('.pg_swatch_text').text(swatch_name);
        }
      });
      // Write selection into native line-item property hidden inputs
      $('.cart_properties input').each(function(){
        var data_class_name = $(this).attr('data-class');
        if(selcted_swatch_name == data_class_name){
          $(this).val(swatch_name);
        }
      });
    });

    // Collect base image + selected piece URLs, send to compositor
    function collectAndSendImages() {
      let imageUrls = [];

      var main_image_url = $('.main_image').attr('src');
      if (main_image_url) {
          imageUrls.push(main_image_url);
      }

      $('.swatch_input:checked').each(function(){
          var display_image = $(this).prev().attr('src');
          if(display_image) {
              imageUrls.push(display_image);
          }
      });

      fetchPhoto(imageUrls);
    }

    function fetchPhoto(imageUrls) {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify({
          imageUrls: imageUrls,
      });

      const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: raw,
          redirect: "follow",
      };

      fetch(COMPOSITE_ENDPOINT, requestOptions)
          .then(response => response.json())
          .then(result => {
              displayPhoto(result.imageUrl);
          })
          .catch(error => console.error(error));
    }

    function displayPhoto(imgUrl) {
      $('.product-slideshow').removeClass('active');
      var mainSlide = $('.product-main-slide[data-index="0"]').find('.photoswipe__image');
      var thumbnail = $('.product__thumb-item[data-index="0"] .product__thumb img');
      mainSlide.attr('data-photoswipe-src', imgUrl)
      mainSlide.fadeOut(500, function() {
          $(this).attr('srcset', imgUrl).on('load', function() {
              $(this).fadeIn(500);
          });
          this.srcset = '';
          this.srcset = imgUrl;
      });

      thumbnail.fadeOut(500, function() {
          $(this).attr('srcset', imgUrl).on('load', function() {
              $(this).fadeIn(500);
          });
          this.srcset = '';
          this.srcset = imgUrl;
      });
      $('.product__thumb-item[data-index="0"] .product__thumb img').trigger('click')
      // Write composite URL into the native line-item property input
      $('.product-single__form .customize_image').val(`${imgUrl}`);
      if(!$('.product-main-slide[data-index="0"]').find('.product-image-main .styled_by_u').length){
        var style_url = $('.product-slideshow').attr('data-style-image');
        if(style_url){
          $('.product-main-slide[data-index="0"]').find('.product-image-main').append(`<span class="styled_by_u"><img src="${style_url}"></span>`).hide().fadeIn(500);
        }
      }
    }

    collectAndSendImages();
  });

  // Reset to original product image and clear all customization properties
  $(document).on('click', '.show_reset.reset_button', function(){
    $('.customize_btn').show();
    $('.pg_swatch_img_text img').each(function(){
      var def = $(this).attr('data-default-src');
      if(def){ $(this).attr('src', def); }
    });
    $('.pg_swatch_img_text .pg_swatch_text').text('As shown');
    $('.reset_button').removeClass('show_reset');
    var selected_main_img = $('.product-main-slide[data-index="0"]').find('.photoswipe__image').attr('data-srcset');
    $('.product-main-slide[data-index="0"]').find('.photoswipe__image').attr('data-photoswipe-src', selected_main_img);
    $('.product-main-slide[data-index="0"]').find('.photoswipe__image').attr('srcset', selected_main_img);
    var selected_thumb__img = $('.product__thumb[data-index="0"] img').attr('data-srcset');
    $('.product__thumb[data-index="0"] img').attr('srcset', selected_thumb__img);
    $('.hidden_input').val('');
    $('.product-main-slide[data-index="0"]').find('.product-image-main .styled_by_u').remove();
  });

  // Mobile tab feature for swatch groups
  mobile_swatch();
  $(window).on('resize', function(){
    mobile_swatch();
  });
  function mobile_swatch(){
    if ($(window).outerWidth() < 767) {
      $('.mob_tab_heading a:first-child').addClass('active');
      $('.single_swatch_main').hide();
      $('.single_swatch_main:first').show();
      $('.mob_tab_heading a').click(function () {
        $('.mob_tab_heading a').removeClass('active');
        $(this).addClass('active');
        $('.single_swatch_main').hide();
        var activeTab = $(this).attr('href');
        $(activeTab).fadeIn();
        return false;
      });
    }else{
      $('.single_swatch_main').show();
    }
  }

  // Size attribute passthrough (kept for parity; harmless if .size_option absent)
  $(document).on('change', '.size_option', function(){
    var size_val = $(this).val();
    $('.size_input').val(size_val);
  })
});
